import { render, staticRenderFns } from "./highAuth.vue?vue&type=template&id=752c802e&scoped=true"
import script from "./highAuth.vue?vue&type=script&lang=js"
export * from "./highAuth.vue?vue&type=script&lang=js"
import style0 from "./highAuth.vue?vue&type=style&index=0&id=752c802e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752c802e",
  null
  
)

export default component.exports